import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/features/store/store";
import { userLogout } from "../../app/features/login/loginSlice";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const logout = async () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/");
    try {
      await dispatch(userLogout()).unwrap();
    } catch (error) {}
  };

  return logout;
};

export default useLogout;
